(ns renolit-roofing-service.shared.util.map)

(defn get-by-id
  [values id]
  (first (filter #(= id (:id %)) values)))
